import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import TestCard from './TestCard'
import TestInstructions from './TestInstructions'
import TestProcess from './TestProcess'
import TestResults from './TestResults'
import TestResultCard from './TestResultCard'
import Button from 'components/UI/Button'
import TestProcessWrapper from './TestProcess/TestProcessWrapper'

import {
  initiateTest,
  logout,
  setActiveCategoryIndex,
  setStep,
  toggleFullscreen,
} from 'routing/fetchingfunction/user/user.action'
import {
  getInitiatedTests,
  selectIsLoading,
  selectPassedTestsCreateBanner,
  selectRegisterStep,
} from 'routing/fetchingfunction/user/user.reducer'

import { useAvailableCategories, useMainCategories } from '../../../../hooks'
import {
  tutorRegistrationTests,
  BACKEND_REGISTRATION_CODES,
  proctoringErrors as proctorViolations,
} from 'constants'
import moment from 'moment'
import { Proctor } from 'lib'
import { StreamUploader } from 'lib/streamUploader'
import ErrorMessageWithExclamation from 'components/UI/ErrorMessageWithExclamation'
import ProctoringInstructions from './ProctoringInstructions'
import TestResultBuffer from './TestResultBuffer'
import { enterFullscreen, exitFullscreen } from 'helpers/fullscreen'
import { useNavigate, useSearchParams } from 'react-router'

const PassTheTest = ({ onContinue }) => {
  const navigate = useNavigate()
  // ref declaration
  const videoRef = useRef(null)
  const canvasRef = useRef(null)
  const failsCount = useRef(0)
  const hasStartedRef = useRef(false)

  const [proctorViolationsStatus, setproctorViolationsStatus] = useState({
    FACE_CENTER_ERROR: 0,
    MULTI_FACE_ERROR: 0,
    NO_FACE_ERROR: 0,
    NO_CAMERA_ERROR: 0,
    NOISE_ERROR: 0,
    TAB_SWICH_ERROR: 0,
    TOTAL: 0,
  })

  const [loading, setLoading] = useState(false)
  const [isProctoringActive, setIsProctoringActive] = useState(false)
  const [streamActivities, setStreamActivities] = useState({
    video: null,
    audio: null,
    screen: null,
  })
  const [proctoringStatus, setProctoringStatus] = useState({
    proctoring_status: 'success',
    proctoring_disqualified_reason: 'N/A',
  })
  const [showWarning, setShowWarning] = useState(false)
  const [logingOut, setLoggingOut] = useState(false)
  const [submittingTest, setSubmittingTest] = useState(false)
  const [lookaway, setlookaway] = useState(false)
  const [warningMessage, setWarningMessage] = useState('Do Not Exit the browser or switch Tabs')
  const [exitConfirmation, setExitConfirmation] = useState(false)

  const registrationStep = useSelector(selectRegisterStep)
  const [snapshots, setSnapshots] = useState([])
  const [warningTriggers, setWarningTriggers] = useState({
    status: true,
    faceOrientation: 0,
    multiFace: 0,
    noVideo: 0,
    noCamera: 0,
    errorMessage: null,
  })
  // const [facecount, setfaceCount] = useState(1)
  const faceRefCount = useRef(1)

  const [proctorVideo, setProctorVideo] = useState(null)
  const showWarningRef = useRef(showWarning)
  const lookawayRef = useRef(lookaway)

  const { formattedClassBannerCategories, takenTests, banners } = useAvailableCategories()
  const passedTests = useSelector(selectPassedTestsCreateBanner)

  const [queryParams, setQueryParams] = useSearchParams()
  const paramTestStep = queryParams.get('test-step')
  const testStatus = queryParams.get('status')

  const isLoading = useSelector(selectIsLoading)
  const [error, setError] = useState(null)

  const initiatedTests = useSelector(getInitiatedTests)

  const mainCategories = useMainCategories()

  const [selectedTests, setSelectedTests] = useState([])
  const [testStep, setTestStep] = useState(1)
  const [testPassedStatus, setTestPassedStatus] = useState(null)

  let uploaderRef = useRef(null)
  const handleProctoringError = useCallback(
    (message) => {
      switch (message) {
        case 'FACE_CENTER_ERROR':
          setWarningMessage('Please do not look away from the screen')
          setWarningTriggers((prev) => ({
            ...warningTriggers,
            noFaceDetected: warningTriggers.faceOrientation + 1,
            errorType: message,
          }))
          break
        case 'MULTI_FACE_ERROR':
          setWarningMessage(`multiple faces detected: You would be flagged if this prompts again`)
          setWarningTriggers((prev) => ({
            ...prev,
            noFaceDetected: prev.multiFace + 1,
            errorType: message,
          }))
          break

        case 'NO_FACE_ERROR':
          setWarningMessage(`Ensure your face is detected on the screen`)
          setWarningTriggers((prev) => ({
            ...prev,
            noFaceDetected: prev.noFaceDetected + 1,
            errorType: message,
          }))
          break
        case 'NO_CAMERA_ERROR':
          setWarningMessage(
            `Camera not detected: Please turn on your camera or ensure the room is well lit so we can detect your face.`
          )
          setWarningTriggers((prev) => ({
            ...prev,
            noCamera: prev.noVideo + 1,
            errorType: message,
          }))
          break

        case 'NOISE_ERROR':
          setWarningMessage(`Noise detected: Please ensure you are in a quiet environment`)
          setWarningTriggers((prev) => ({
            ...prev,
            noise: prev.noise + 1,
            errorType: message,
          }))
          break

        default:
          setWarningMessage(
            `Ensure you do not switch tabs or include any foreign object in the video`
          )
          break
      }
    },
    [showWarning]
  )

  const handleStartProctoring = async () => {
    if (hasStartedRef.current) {
      return
    }
    hasStartedRef.current = true

    try {
      await Proctor.setup({
        onVideoFrame: (cameraStream) => {
          if (videoRef.current) {
            const video = videoRef.current

            if (video.srcObject !== cameraStream) {
              video.srcObject = cameraStream
            }

            setStreamActivities((prev) => ({ ...prev, video: cameraStream }))
          }
        },
        onAudioStream: (audioStream) => {
          console.log('Audio stream initialized', audioStream)
          setStreamActivities((prev) => ({ ...prev, audio: audioStream }))
        },
        // onScreenStream: (screenStream) => {
        //   console.log('Screen stream initialized', screenStream)
        //   setStreamActivities((prev) => ({ ...prev, screen: screenStream }))
        // },
        onTabSwitch: () => {
          console.log('Tab switch detected')
          setShowWarning(true)
          // handleErrorCount(proctorViolations.TAB_SWICH_ERROR, 0)
          setWarningMessage(`You switched tabs! Please return to the test.`)
        },
        onMultipleFaceDetection: (count) => {
          failsCount.current += 1
          console.log('[Trigger from Component]: Detection triggered', count)
          handleInstructionError(proctorViolations.MULTI_FACE_ERROR, count)
        },
        onvideoDetect: (isCameraOpen) => {
          console.log(
            (failsCount.current += 1),
            isCameraOpen,
            '[SET CAMERA]: handleproctoring SET cammera error on origiinal first proctoring ++++++++++++++++++++++++++++++++++++++++++++====================================='
          )
          handleInstructionError(proctorViolations.NO_CAMERA_ERROR, 0)
        },
        noFaceDetected: () => {
          console.log('[Trigger from Component]: No face triggered')

          handleInstructionError(proctorViolations.NO_FACE_ERROR, 0)
        },
        onLookaway: (status) => {
          setlookaway(status)
          handleInstructionError(proctorViolations.FACE_CENTER_ERROR, status ? 0 : 1)
        },
        onSoundDetect: (status) => {
          handleInstructionError(proctorViolations.NOISE_ERROR, status ? 0 : 1)
        },

        videoElement: videoRef.current,
        canvasElement: canvasRef.current,
      })
      setIsProctoringActive(true)

      return { screenShare: true }
    } catch (error) {
      setIsProctoringActive(false)

      console.error('Error starting proctoring:', error)
      throw new Error(
        `Proctoring setup was blocked: ${error.message ?? ' please allow access to your camera and microphone to continue.'}`
      )
    } finally {
      hasStartedRef.current = false
    }
  }

  const rebindProctoring = () => {
    setProctoringStatus({
      proctoring_status: 'success',
      proctoring_disqualified_reason: 'N/A',
    })
    Proctor.updateElement({
      onVideoFrame: (newStream) => {
        console.log('Rebinding video stream', newStream)

        videoRef.current.srcObject = newStream

        setStreamActivities((prev) => ({ ...prev, video: newStream }))
      },
      onAudioStream: (audioStream) => {
        console.log('Audio stream initialized', audioStream)
        setStreamActivities((prev) => ({ ...prev, audio: audioStream }))
      },
      // onScreenStream: (screenStream) => {
      //   console.log('Screen stream initialized', screenStream)
      //   setStreamActivities((prev) => ({ ...prev, screen: screenStream }))
      // },
      // .
      onTabSwitch: () => {
        handleErrorCount(proctorViolations.TAB_SWICH_ERROR, 0)
        setWarningMessage(`You switched tabs! Please return to the test.`)
      },
      videoElement: videoRef.current,
      canvasElement: canvasRef.current,
      onMultipleFaceDetection: (count) => {
        failsCount.current += 1
        handleErrorCount(proctorViolations.MULTI_FACE_ERROR, count)
      },
      onvideoDetect: (isCameraclosed) => {
        isCameraclosed
          ? handleErrorCount(proctorViolations.NO_CAMERA_ERROR, 0)
          : handleErrorCount('CAMERA RESUME', 1)
      },
      noFaceDetected: () => {
        handleErrorCount(proctorViolations.NO_FACE_ERROR, 0)
      },
      onLookaway: (status) => {
        setlookaway(status)
        handleErrorCount(proctorViolations.FACE_CENTER_ERROR, status ? 0 : 1)
      },
      onSoundDetect: (status) => {
        handleErrorCount(proctorViolations.NOISE_ERROR, status ? 0 : 1)
      },
    })

    handlesnapshot()
    setWarningTriggers({
      status: true,
      faceOrientation: 0,
      multiFace: 0,
      noVideo: 0,
      noCamera: 0,
      errorMessage: null,
      noise: 0,
    })
  }

  useEffect(() => {
    showWarningRef.current = showWarning
  }, [showWarning])

  useEffect(() => {
    lookawayRef.current = lookaway
  }, [lookaway])

  const handleInstructionError = (errorType, faces = 1) => {
    console.log('[Triggering]: Instruction called', errorType, faces, showWarning)
    faceRefCount.current = faces

    console.log('Number of faces', errorType, faces)

    setProctoringStatus((prev) => ({
      ...prev,
      proctoring_status: 'flagged',
      proctoring_disqualified_reason: faces === 1 ? null : errorType,
    }))
  }

  const handleErrorCount = (errorType, faces = 1) => {
    console.log('[Triggering]: handleErrorCount called', errorType, faces, showWarning)

    // setfaceCount(faces)
    faceRefCount.current = faces

    // Stop if warning already active
    if (showWarningRef.current || lookawayRef.current) return

    // Special case: tab switch error (doesn't affect TOTAL)
    if (errorType === proctorViolations.TAB_SWICH_ERROR) {
      setproctorViolationsStatus((prev) => ({
        ...prev,
        [errorType]: (prev[errorType] || 0) + 1,
      }))

      return
    }

    // Update violations
    setproctorViolationsStatus((prev) => ({
      ...prev,
      [errorType]: (prev[errorType] || 0) + 1,
      TOTAL: (prev.TOTAL || 0) + 1,
    }))

    // Immediate cancel case
    // if (errorType === proctorViolations.NO_CAMERA_ERROR && faces === 0) {
    //   handleStop(1).then(() => {
    //     resetStep()
    //     exitFullscreen(() => dispatch(toggleFullscreen(false)))
    //   })
    //   return
    // }

    // Update proctoring status
    setProctoringStatus((prev) => ({
      ...prev,
      proctoring_status: 'flagged',
      proctoring_disqualified_reason: errorType,
    }))

    setShowWarning(true)

    handleProctoringError(errorType)
  }

  const handlesnapshot = async () => {
    const snapshot = await Proctor.takeSnapshot(canvasRef.current, videoRef.current)
    setSnapshots((prev) => [...prev, snapshot].filter(Boolean))
  }

  const handleStop = async (nextStepValue = 1) => {
    let finalVideoBlob = null

    try {
      if (uploaderRef.current) {
        finalVideoBlob = await uploaderRef.current.stop()
        setProctorVideo(finalVideoBlob)
      }

      if (nextStepValue === 1) {
        setIsProctoringActive(false)
        hasStartedRef.current = false

        // Stop all proctoring services
        await Proctor.stop()

        // Release video element
        if (videoRef.current) {
          videoRef.current.srcObject = null
        }
        setStreamActivities({
          video: null,
          audio: null,
          screen: null,
        })
      }
    } catch (err) {
      console.error('Failed to stop recorder:', err)
    } finally {
      uploaderRef.current = null

      // ✅ return the ACTUAL blob, not state
    }

    setProctoringStatus({
      proctoring_status: 'success',
      proctoring_disqualified_reason: 'N/A',
    })
    setproctorViolationsStatus({
      FACE_CENTER_ERROR: 0,
      MULTI_FACE_ERROR: 0,
      NO_FACE_ERROR: 0,
      NO_CAMERA_ERROR: 0,
      NOISE_ERROR: 0,
      TOTAL: 0,
    })

    setSnapshots([])
    // uploaderRef.current = null

    console.log('Suppored to submited')

    return finalVideoBlob
  }

  const initializedStreaming = async () => {
    try {
      if (!streamActivities.video) {
        throw new Error('Video stream not initialized')
      }

      if (!streamActivities.audio) {
        throw new Error('Audio stream not initialized')
      }

      // if (!streamActivities.screen) {
      //   throw new Error('Screen stream not initialized')
      // }

      if (uploaderRef.current) {
        throw new Error('Uploader already initialized')
      }

      console.log('first initialized')
      uploaderRef.current = new StreamUploader({
        serverUrl: 'https://your-server-url.com/upload', // Replace with your server URL
        videoStream: streamActivities.video,
        audioStream: streamActivities.audio,
        screenStream: streamActivities.screen,
        onDataAvailable: (data) => {
          console.log('Data available for upload:', data)
        },
      })
      uploaderRef.current.init()
      // setIsRecording(true)
      uploaderRef.current.start()
      console.log('Streaming started', uploaderRef.current)
    } catch (error) {
      console.log(
        error.message,
        streamActivities.video,
        streamActivities.audio,
        streamActivities.screen,
        uploaderRef.current
      )
      throw error.message
      // console.error('Error initializing streaming:', error)
    }
  }

  const dispatch = useDispatch()

  const { lastSubmittedTest, lastTestCategoryName } = useSelector((state) => state.user)

  useEffect(() => {
    if (paramTestStep) {
      setTestStep(7)
    }
  }, [])

  useEffect(() => {
    setSelectedTests([...takenTests])
  }, [takenTests])

  useEffect(() => {
    if (!submittingTest && takenTests && takenTests.length > 0) {
      setTestStep(7)
    }
  }, [takenTests])

  const allPassedTest = useMemo(
    () => takenTests.filter((test) => test?.test?.result?.toLowerCase() === 'pass'),
    [takenTests]
  )
  const isBannercreationAvailable =
    formattedClassBannerCategories > banners || allPassedTest > banners
  const isAnypassed = allPassedTest.length > 0

  const handleSelect = (test) => {
    setSelectedTests((prevSelectedTests) => {
      const check =
        takenTests.findIndex((passedTest) => passedTest.category.category_slug === test.slug) === -1
      const isExist =
        prevSelectedTests.findIndex((selectedTest) => selectedTest.id === test.id) === -1 &&
        takenTests.findIndex((passedTest) => passedTest.category.category_slug === test.slug) === -1

      if (isExist) {
        return [...prevSelectedTests, test]
      }

      return prevSelectedTests.filter((prevSelectedTest) => prevSelectedTest.id !== test.id)
    })
  }

  const handleResetWarning = () => {
    console.log(
      'first',
      faceRefCount.current,
      warningTriggers.errorType,
      lookaway,
      '==============================='
    )
    // dont count error is it was triggered by no face detected
    if (
      (faceRefCount.current !== 1 &&
        warningTriggers.errorType !== proctorViolations.FACE_CENTER_ERROR) ||
      lookaway
    ) {
      return
    }
    setShowWarning(false)
    setWarningMessage(null)
    // setfaceCount(1)
    faceRefCount.current = 1
  }

  const handleSubmitSelectedCategories = async () => {
    try {
      if (selectedTests.length < 1) {
        throw new Error('Select at least one category to take the test')
      }

      setTestStep((prevTestStep) => prevTestStep + 1)
    } catch (error) {
      setError(`Test initiation failed:  ${error?.message || error || 'Please try again.'}`)

      console.error('Error initiating test:', error?.message)
    }

    return
  }

  const handleSubmitInstructions = async (assignStep) => {
    const getSlugArray = selectedTests.map((item) => item.slug || item.category_slug)
    try {
      await dispatch(initiateTest(getSlugArray)).unwrap()

      setTestStep((prevTestStep) => assignStep ?? prevTestStep + 1)
    } catch (error) {
      setError(`Test initiation failed:  ${error?.message || error || 'Please try again.'}`)

      throw error
    }

    return
  }

  const handleTestResubmit = async (reSelectedTests) => {
    console.log(reSelectedTests)
    try {
      await dispatch(initiateTest(reSelectedTests)).unwrap()

      dispatch(setActiveCategoryIndex(0))
      setTestStep(3)
    } catch (error) {
      console.log(reSelectedTests)

      setError(`Test initiation failed:  ${error?.message || error || 'Please try again.'}`)

      console.error('Error initiating test:', error?.message)
    }
  }

  const handleSubmitProctoringInstructions = () => {
    console.log('Submitting proctoring instructions and initializing streaming', streamActivities)
    initializedStreaming()
      .then(() => {
        setTestStep((prevTestStep) => prevTestStep + 1)

        console.log('Streaming initialized after proctoring instructions submission')
      })
      .catch((e) => {
        console.log(e)
        setError(`Streaming initialization failed:  ${e?.message || e || 'Please try again.'}`)
      })
  }
  console.log(testStep)
  const handleSubmitTests = (testPassedStatus) => {
    paramTestStep && setQueryParams({})
    setTestPassedStatus(testPassedStatus)
    setTestStep((prevTestStep) => prevTestStep + 1)
  }

  const resetStep = () => {
    setTestStep((!submittingTest && takenTests && takenTests.length > 0) || paramTestStep ? 7 : 1)
  }

  const handleCancelTest = (testPassedStatus) => {
    handleStop(0)
      .then(() => {
        if (testPassedStatus) {
          setTestPassedStatus(testPassedStatus)
          handleSubmitTests(testPassedStatus)
        } else {
          resetStep()
        }
      })
      .catch((e) => console.log(e))
  }

  const handleExitTest = (err) => {
    setExitConfirmation(false)
    err && setError(err)

    handleStop()
      .then(() => resetStep())
      .catch((e) => console.log(e))
  }

  const handleContinueTest = (nextStepValue) => {
    if (nextStepValue === 1) {
      setTestStep((prevTestStep) => prevTestStep + 1)
    } else {
      enterFullscreen().then(() => {
        setTestStep((prevTestStep) => prevTestStep - 1)
        dispatch(toggleFullscreen(true))
      })
    }
    setProctoringStatus({
      proctoring_status: 'success',
      proctoring_disqualified_reason: 'N/A',
    })

    setSnapshots([])
    handleStop(nextStepValue)
  }

  const handleSubmitOverAllResults = () => {
    if (onContinue) {
      return onContinue()
    }
    setLoading(true)

    // Remove query params if present
    if (paramTestStep) {
      setQueryParams({})
    }

    const isBannerStep =
      registrationStep === BACKEND_REGISTRATION_CODES.COMPLETED ||
      registrationStep === BACKEND_REGISTRATION_CODES.TUTOR_CREATE_BANNER ||
      testStatus === 'completed'

    // Determine next step + next route
    const nextStep = isBannerStep
      ? BACKEND_REGISTRATION_CODES.TUTOR_CREATE_BANNER
      : BACKEND_REGISTRATION_CODES.TUTOR_KYC

    const nextRoute = isBannerStep ? '/tutor/register/create-banner' : '/tutor/register/kyc'

    // Dispatch step update
    dispatch(
      setStep({
        step: nextStep,
        skipBackendUpdate: true,
      })
    )

    // Navigate after delay
    setTimeout(() => {
      setLoading(false)
      navigate(nextRoute, { replace: true })
    }, 3000)
  }

  const handleExitRegistration = async () => {
    setLoggingOut(true)
    try {
      // Dispatch logout and wait for it to complete
      await dispatch(logout()).unwrap()
      //console.log('Logout completed, redirecting to homepage')

      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('Logout completed, redirecting to homepage')
      }

      // Only navigate after logout is complete
      navigate('/')
    } catch (error) {
      console.error('Error during logout:', error)
      // Still try to navigate to homepage even if logout fails
      navigate('/')
    } finally {
      setLoggingOut(false)
    }
  }

  const testCardsContent = tutorRegistrationTests.map((tutorRegistrationTest) => {
    const foundTest = mainCategories.find((test) => test.slug === tutorRegistrationTest.slug)
    const icon = foundTest?.icon || ''
    const description = foundTest?.description || 'Description not available'
    const name = foundTest?.name || tutorRegistrationTest.name
    const id = foundTest?.id || tutorRegistrationTest.id

    return (
      <TestCard
        key={id}
        id={id}
        title={tutorRegistrationTest.name}
        description={tutorRegistrationTest.description}
        icon={tutorRegistrationTest.icon}
        onSelect={handleSelect}
        slug={tutorRegistrationTest.slug}
        name={tutorRegistrationTest.name}
        isSelected={selectedTests.findIndex((selectedTest) => id === selectedTest.id) !== -1}
      />
    )
  })

  const selectTestsContent = (
    <div className="bg-[#FEEBDD] rounded-lg p-8 text-[#F67443] w-full">
      <p className="text-white absolute top-8 -mt-20">
        Select the categories you’d like to be tested on to set up your tutor profile. You can
        choose multiple categories to take the corresponding test.
      </p>

      {error && (
        <div className="!mb-4 text-error-500">
          <p className="font-bold">Following errors occur</p>
          <ErrorMessageWithExclamation text={error} />
        </div>
      )}
      <div></div>
      <div className="grid grid-cols-4 grid-rows-2 gap-[10px]">{testCardsContent}</div>
      <div className="max-w-[590px] w-full mt-6 flex flex-col items-center justify-start mx-auto">
        <Button
          variant="static"
          className={`w-full  ${selectedTests.length < 1 && '!bg-gray-300 text-gray-600'}`}
          disabled={selectedTests.length < 1}
          onClick={handleSubmitSelectedCategories}
          isLoading={isLoading}
        >
          Continue
        </Button>
      </div>
    </div>
  )

  const instructionsContent = (
    <div className="bg-[#FEEBDD] rounded-lg pb-8 px-8 text-[#F67443] max-w-[800px] w-full mx-auto">
      <TestInstructions
        selectedTests={selectedTests}
        onSubmit={handleSubmitInstructions}
        cancelProctor={handleStop}
        proctorVideo={proctorVideo}
        isProctoringActive={isProctoringActive}
        isLoading={isLoading}
        onCancel={handleCancelTest}
      />
    </div>
  )
  const proctoringRulesContent = (
    <div className="bg-[#FEEBDD] relative rounded-lg pb-8 px-8 text-[#F67443] max-w-[800px] w-full mx-auto">
      <ProctoringInstructions
        selectedTests={selectedTests}
        onSubmit={handleSubmitProctoringInstructions}
        proctorVideo={proctorVideo}
        isProctoringActive={isProctoringActive}
        videoRef={videoRef}
        canvasRef={canvasRef}
        onReady={handleStartProctoring}
        isLoading={isLoading}
        onCancel={handleExitTest}
        setShowWarning={setShowWarning}
        showWarning={showWarning}
        warningMessage={warningMessage}
        onReset={handleResetWarning}
        proctorStatus={proctoringStatus.proctoring_disqualified_reason}
      />
    </div>
  )

  const testProcessContent = (
    <div className="max-w-[860px] mx-auto">
      <TestProcessWrapper>
        <TestProcess
          onTestSubmit={handleSubmitTests}
          onCancelTest={handleCancelTest}
          onExitTest={handleExitTest}
          snapshots={snapshots}
          setSnapshots={setSnapshots}
          onProctorStop={handleStop}
          warningMessage={warningMessage}
          setWarningMessage={setWarningMessage}
          exitConfirmation={exitConfirmation}
          proctoringStatus={proctoringStatus}
          setProctoringStatus={setProctoringStatus}
          onSnapshot={handlesnapshot}
          setShowWarning={setShowWarning}
          showWarning={showWarning}
          onReset={handleResetWarning}
          facecount={faceRefCount.current}
          videoRef={videoRef}
          canvasRef={canvasRef}
          streamActivities={streamActivities}
          onRebind={rebindProctoring}
          proctorViolationsStatus={proctorViolationsStatus}
          onContinue={handleContinueTest}
          resetStep={resetStep}
          submittingTest={submittingTest}
          setSubmittingTest={setSubmittingTest}
        />
      </TestProcessWrapper>
    </div>
  )

  const testResultsContent = (
    <div className="max-w-[800px] mx-auto">
      <TestResults
        passedStatus={testPassedStatus}
        testName={lastTestCategoryName}
        onContinue={handleContinueTest}
        resumeStream={initializedStreaming}
      />
    </div>
  )

  const testResultsBuffer = (
    <div className="max-w-[800px] mx-auto">
      <TestResultBuffer
        passedStatus={testPassedStatus}
        testName={lastTestCategoryName}
        onContinue={handleContinueTest}
        resumeStream={initializedStreaming}
      />
    </div>
  )

  const testResultCardsContent = tutorRegistrationTests.map((tutorRegistrationTest) => {
    const tutorRegistrationTestFound = mainCategories.find(
      (test) => test.slug === tutorRegistrationTest.slug
    )

    const icon = tutorRegistrationTest?.icon || ''
    const description = tutorRegistrationTest?.description || 'Description not available'
    const passedTest = takenTests.find(
      (passedTest) =>
        (passedTest?.category?.category_slug || passedTest?.category?.slug) ===
        tutorRegistrationTestFound?.slug
    )
    const nextAvailableDate = passedTest?.test?.next_available_date
    let isTestBlocked = !!passedTest

    if (nextAvailableDate) {
      const now = moment()

      const nextAvailableDay = moment(nextAvailableDate)

      const milliseconds = nextAvailableDay.diff(now, 'milliseconds')

      if (milliseconds <= 0 && passedTest.test.level !== 'expert') {
        isTestBlocked = false
      }
    }

    console.log(passedTest?.category?.name, isTestBlocked)

    return isTestBlocked ? (
      <TestResultCard
        key={tutorRegistrationTestFound.id}
        id={tutorRegistrationTestFound.id}
        title={tutorRegistrationTest.name}
        description={description}
        isPassed={passedTest?.test?.is_passed}
        level={passedTest?.test?.level}
        result={passedTest?.test?.result}
        nextAvailableDate={passedTest?.test?.next_available_date}
        icon={icon}
        className="!p-[24px]"
      />
    ) : (
      <TestCard
        key={tutorRegistrationTest.id}
        id={tutorRegistrationTest.id}
        title={tutorRegistrationTest.name}
        description={description}
        icon={icon}
        onSelect={handleSelect}
        slug={tutorRegistrationTest.slug}
        name={tutorRegistrationTest.name}
        hasBeenTaken={''}
        isSelected={
          selectedTests.findIndex(
            (selectedTest) => tutorRegistrationTest.id === selectedTest.id
          ) !== -1
        }
      />
    )
  })

  const testOverallResultsContent = (
    <div className="bg-[#FEEBDD] rounded-lg p-8 text-[#F67443] w-full">
      <p className="text-white absolute top-8 text-center w-full -mt-20">
        You may select additional tests available to you for completion, then click Continue.{' '}
      </p>

      <div className="grid grid-cols-4 grid-rows-2 gap-[10px]">{testResultCardsContent}</div>
      <div className="max-w-[590px] w-full mt-6 flex flex-col items-center justify-start mx-auto">
        {selectedTests.length > takenTests.length && (
          <Button
            className={`${takenTests.length === selectedTests.length && 'bg-gray-300 !text-gray-600'} w-full mt-4`}
            onClick={() => {
              const reselectedTests = selectedTests.filter(
                (item) =>
                  item.id !== undefined && item.slug !== undefined && item.title !== undefined
              )

              console.log('[Clicked test continue button returns]=>', reselectedTests)
              handleTestResubmit(reselectedTests)
            }}
          >
            Continue to Next Test
          </Button>
        )}
        {isAnypassed && isBannercreationAvailable && (
          <Button isLoading={loading} className="w-full mt-4" onClick={handleSubmitOverAllResults}>
            {registrationStep === BACKEND_REGISTRATION_CODES.COMPLETED ||
            registrationStep === BACKEND_REGISTRATION_CODES.TUTOR_CREATE_BANNER ||
            (testStatus && testStatus === 'completed')
              ? 'Continue to Banner Setup'
              : 'Continue to KYC'}
          </Button>
        )}

        {(selectedTests.length <= takenTests.length || !isAnypassed) && (
          <Button isLoading={logingOut} className="w-full mt-4" onClick={handleExitRegistration}>
            Log Out
          </Button>
        )}
      </div>
    </div>
  )

  const testContent = useMemo(() => {
    switch (testStep) {
      case 1:
        return selectTestsContent
      case 2:
        return instructionsContent
      case 3:
        return proctoringRulesContent
      case 4:
        return testProcessContent
      case 5:
        return testResultsContent
      case 6:
        return testResultsBuffer

      case 7:
        return testOverallResultsContent
      default:
        return selectTestsContent
    }
  }, [
    testStep,
    selectedTests,
    mainCategories,
    error,
    showWarning,
    faceRefCount.current,
    loading,
    streamActivities,
  ])

  return <div className="px-8 mx-auto my-16 relative">{testContent}</div>
}

export default PassTheTest
